export default "__VITE_PUBLIC_ASSET__7f1e4f8a__"